import cn from 'classnames'
import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestModal, {
  ModalProps,
} from 'ext-ui/design-system/generated/latest/components/Modal/Modal'
import GeneratedLiveModal from 'ext-ui/design-system/generated/live/components/Modal/Modal'
import React, { ReactElement } from 'react'

function channelClassName(channel: 'live' | 'latest'): string {
  return `design-system-channel-${channel}`
}

function renderDesignSystemModal(
  Component: typeof GeneratedLiveModal,
  channel: 'live' | 'latest',
  props: ModalProps,
): ReactElement {
  const { className = '', ...rest } = props

  return (
    <Component {...rest} className={cn(className, channelClassName(channel))} />
  )
}

function LiveModal(props: ModalProps): ReactElement {
  return renderDesignSystemModal(GeneratedLiveModal, 'live', props)
}

function LatestModal(props: ModalProps): ReactElement {
  return renderDesignSystemModal(GeneratedLatestModal, 'latest', props)
}

function Modal(props: ModalProps): ReactElement {
  const ResolvedModal = useResolvedDesignSystemComponent(LiveModal, LatestModal)

  return <ResolvedModal {...props} />
}

export default Modal
export type { ModalProps }
